import classNames from 'classnames'
import { ReactNode } from 'react'

export const categoryNames = {
  implicit: 'Implicit',
  explicit: 'Explicit',
  crafted: 'Crafted',
  fractured: 'Fractured',
  enchant: 'Enchant',
  custom: 'Custom'
}

export const AbstractCategory = ({
  name,
  className,
  children
}: {
  name: string
  className?: string
  children: ReactNode
}) => (
  <div className="poe-item-stat-category">
    <h3>{name}</h3>
    <ul className={classNames('poe-item-stats', className)}>{children}</ul>
  </div>
)
